// import { createApp } from 'vue'
// import Vue from 'vue'
import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import App from "./App.vue";
import router from "./router/index";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/style/index.css";
const head = createHead();
const app = createApp(App);
app.use(head);
app.use(router);
app.use(ElementPlus);
app.mount("#app");
